__turbopack_context__.v({
  "animate": "index-module-scss-module__Rbm-8G__animate",
  "row": "index-module-scss-module__Rbm-8G__row",
  "rowAnimtion": "index-module-scss-module__Rbm-8G__rowAnimtion",
});
